<div class="search-container">
  <h2 class="mat-h2">Buscar reuniones</h2>
  <div>
    <form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
      <div class="full-width">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Termino de búsqueda</mat-label>
          <input matInput autocomplete="off" formControlName="searchTerm">
        </mat-form-field>
      </div>
      <div class="flex-wrap">
        <div class="inline-flex" style="margin-right: 12px;">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Realizadas desde</mat-label>
            <input matInput [matDatepicker]="fromDate" formControlName="fromDate">
            <mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
            <mat-datepicker #fromDate></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="inline-flex" style="margin-left: 12px;">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Hasta</mat-label>
            <input matInput [matDatepicker]="toDate" formControlName="toDate">
            <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
            <mat-datepicker #toDate></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="full-width">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Tipo de reunión</mat-label>
          <mat-chip-set #chipTypesList>
            <mat-chip *ngFor="let type of selectedTypes" [selectable]="selectable" [removable]="removable"
                      (removed)="removed(type, selectedTypes, allTypes, 'type')">
              {{type.nombre}}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
            <input #typesInput formControlName="type" [matAutocomplete]="autoTypes" [matChipInputFor]="chipTypesList">
          </mat-chip-set>
          <mat-autocomplete #autoTypes="matAutocomplete"
                            (optionSelected)="selected($event, allTypes, selectedTypes, 'type', typesInputRef)">
            <mat-option *ngFor="let type of filteredTypes | async" [value]="type">
              {{type.nombre}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="full-width">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Cursos</mat-label>
          <mat-chip-set #chipCourseList>
            <mat-chip *ngFor="let course of selectedCourses" [selectable]="selectable" [removable]="removable"
                      (removed)="removed(course, selectedCourses, allCourses, 'course')">
              {{course.nombre}}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
            <input #coursesInput formControlName="course" [matAutocomplete]="autoCourses"
                   [matChipInputFor]="chipCourseList">
          </mat-chip-set>
          <mat-autocomplete #autoCourses="matAutocomplete"
                            (optionSelected)="selected($event, allCourses, selectedCourses, 'course', coursesInputRef)">
            <mat-option *ngFor="let course of filteredCourses | async" [value]="course">
              {{course.nombre}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="full-width">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Estado de la reunión</mat-label>
          <mat-chip-set #chipStateList>
            <mat-chip *ngFor="let state of selectedStates" [selectable]="selectable" [removable]="removable"
                      (removed)="removed(state, selectedStates, allStates, 'state')">
              {{state.nombre}}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
            <input #statesInput formControlName="state" [matAutocomplete]="autoStates"
                   [matChipInputFor]="chipStateList">
          </mat-chip-set>
          <mat-autocomplete #autoStates="matAutocomplete"
                            (optionSelected)="selected($event, allStates, selectedStates, 'state', statesInputRef)">
            <mat-option *ngFor="let state of filteredStates | async" [value]="state">
              {{state.nombre}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <mat-dialog-actions align="center" *ngIf="!searching; else searchingSpinner">
        <button mat-button [mat-dialog-close]="">Cancelar</button>
        <button mat-raised-button type="submit" color="primary">Buscar</button>
      </mat-dialog-actions>
      <ng-template #searchingSpinner>
        <div class="full-width">
          <mat-spinner style="margin: 0 auto;"></mat-spinner>
        </div>
      </ng-template>
    </form>
  </div>
</div>
